// Import dependencies
import React, { useRef, useState, useEffect } from "react";
// import * as tf from "@tensorflow/tfjs";
// 1. TODO - Import required model here
import * as tf from '@tensorflow/tfjs';
import * as cocossd from '@tensorflow-models/coco-ssd';
import Webcam from "react-webcam";
import "../App.css";
import Heading from "./Heading";
import ParticleBg from "./ParticlesBg";
import H5 from "./H5";
// 2. TODO - Import drawing utility here
import { drawRect } from "./drawRect";
import Button from 'react-bootstrap/Button';

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      || (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));
}

function ObjectDetect() {
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const [facingMode, setFacingMode] = useState("user");
  const isMobile = Boolean(isMobileDevice());
  
  // Main function
  const runCoco = async () => {
    // 3. TODO - Load network 
    const net = await cocossd.load();
    
    //  Loop and detect hands
    setInterval(() => {
      detect(net);
    }, 10);
  };

  const detect = async (net) => {
    // Check data is available
    if (
      typeof webcamRef.current !== "undefined" &&
      webcamRef.current !== null &&
      webcamRef.current.video.readyState === 4
    ) {
      // Get Video Properties
      const video = webcamRef.current.video;
      const videoWidth = webcamRef.current.video.videoWidth;
      const videoHeight = webcamRef.current.video.videoHeight;

      // Set video width
      webcamRef.current.video.width = videoWidth;
      webcamRef.current.video.height = videoHeight;

      // Set canvas height and width
      canvasRef.current.width = videoWidth;
      canvasRef.current.height = videoHeight;

      // 4. TODO - Make Detections
      const obj = await net.detect(video);
      console.log(obj);

      // Draw mesh
      const ctx = canvasRef.current.getContext('2d');

      // 5. TODO - Update drawing utility
      // drawSomething(obj, ctx)  
      drawRect(obj,ctx)
    }
  };

  tf.setBackend('webgl').then(() => {
    console.log('Using backend:', tf.getBackend());
    // Now that the backend is set, load your model or execute TF.js operations.
    // Example: loadModel().then(model => { ... });
  });

  useEffect(()=>{runCoco()},[]);

  const toggleCamera = async () => {
    setFacingMode(facingMode === "user" ? "environment" : "user");
  };

  return (
    <div className="App">
      <div className="App-header">
        <ParticleBg />
        <br></br>
        <Heading content="Real Time Object Detection" />
        <H5 content="Instantly identifies and labels objects in your webcam's view using TensorFlow.js and COCO-SSD model." />
        <H5 content="You can see bounding boxes and labels around each detected object directly on your screen." />
        <H5 content="No downloads or installations required—experience the power of AI directly in your web browser." />
        <H5 content="Please allow camera access and wait for a while to load" />
        <br></br>
        {isMobile && (
                <Button onClick={toggleCamera} variant="dark">Toggle Front/Back Camera</Button>
        )}
      </div>
      <div className="body">
      <Webcam
          ref={webcamRef}
          muted={true} 
          videoConstraints={{ facingMode }}
          style={{
            position: "absolute",
            marginLeft: "auto",
            marginRight: "auto",
            left: 0,
            right: 0,
            textAlign: "center",
            zindex: 9,
            width: '80vw',
            height: '80vh',
          }}
        />

        <canvas
          ref={canvasRef}
          style={{
            position: "absolute",
            marginLeft: "auto",
            marginRight: "auto",
            left: 0,
            right: 0,
            textAlign: "center",
            zindex: 8,
            width: '80vw',
            height: '80vh',
          }}
        />
      </div>
    </div>
  );
}

export default ObjectDetect;